<template>
  <div class="team">
    <p class="text-h6 mb-1">コース設定</p>
    <div class="mb-5">
    <v-btn
      @click="toProcess"
      class="course-btn ma-1"
      color="info"
      v-if="isMobile"
    >
      参加手順
    </v-btn>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="toProcess"
            class="course-btn ma-1"
            color="info"
            v-bind="attrs"
            v-on="on"
          >
            参加手順
          </v-btn>
        </template>
        <span>参加手順についてはこちらをご確認ください。</span>
      </v-tooltip>
      <v-dialog v-model="participationDialog" scrollable>
        <v-card>
          <v-toolbar
            flat
            dense
            class="d-flex flex-row-reverse"
          >
            <v-btn
              fab
              small
              @click="participationDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <ProcessParticipation />
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-btn
        @click="toCourse"
        class="course-btn ma-1"
        color="info"
        v-if="isMobile"
      >
        コースの説明
      </v-btn>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="toCourse"
            class="course-btn ma-1"
            color="info"
            v-bind="attrs"
            v-on="on"
          >
            コースの説明
          </v-btn>
        </template>
        <span>すべてのコースを紹介しています。<br>まずはこちらをご覧ください。</span>
      </v-tooltip>
      <v-dialog v-model="courseDialog" scrollable>
        <v-card>
          <v-toolbar
            flat
            dense
            class="d-flex flex-row-reverse"
          >
            <v-btn
              fab
              small
              @click="courseDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <ProcessCourse/>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!isLight && getCampaignOption.is_course_pack"
            @click="toCoursePack"
            class="course-btn ma-1"
            style="width:230px"
            color="info"
            v-bind="attrs"
            v-on="on"
          >
            おすすめパック
          </v-btn>
        </template>
      <span>取り組むコースが決まらない方は、<br>おすすめパックを見てみましょう。</span>
      </v-tooltip>
    </div>

    <div class="mb-6">
      <h4 class="course-title">
        人気コースランキング
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="blue" v-bind="attrs" v-on="on" style="margin-left:10px">
              mdi-help-circle
            </v-icon>
          </template>
          <span>ランキングは1時間に1回更新されます。(9時から21時)</span>
        </v-tooltip>
      </h4>
      <v-row class="my-4">
        <v-col cols="12" md="4" v-for="(course, index) in this.courseRanking" :key="index" class="py-0">
          <v-list-item>
            <v-list-item-icon class="rank-icon">
              <v-icon v-if="course.rank === 1" color="gold" large>mdi-crown</v-icon>
              <v-icon v-if="course.rank === 2" color="silver" large>mdi-crown</v-icon>
              <v-icon v-if="course.rank === 3" color="bronze" large>mdi-crown</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :class="{'font-weight-black': course.rank === 1}">
                {{course.rank}} 位  {{course.name}}
              </v-list-item-title>
              <v-list-item-subtitle>
                参加人数 {{course.participants}}人
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </div>

    <div class="course-select">
      <h4 class="course-title">コース選択</h4>
      <v-alert
        v-if="selectMessage != ''"
        border="left"
        colored-border
        type="info"
        elevation="2"
        style="font-size: 90%"
      >
        <span v-html="selectMessage"></span>
      </v-alert>
      <v-alert
        v-if="hasError"
        border="left"
        colored-border
        type="error"
        elevation="2"
        style="font-size: 90%"
      >
        {{ errorMessage }}
      </v-alert>
      <div v-if="getCampaignOption.is_course_pack" style="display: inline-block" class="mb-4">
        <v-btn
          type="submit"
          @click="customize"
          class="ma-2 rounded-pill"
          :class="{'orange white--text': !selectedCoursePack}"
          :disabled="!isCampaignPeriod || (isReadOnly && !!selectedCoursePack)"
          small
          >
          パック未選択
        </v-btn>
        <span v-for="coursePack in coursePackList" :key=coursePack.id>
          <v-btn
          @click="assignCoursePack(coursePack.id)"
          class="ma-2 rounded-pill"
          :class="{'orange white--text': coursePack.id == selectedCoursePack}"
          :disabled="!isCampaignPeriod || (isReadOnly && coursePack.id != selectedCoursePack) "
          small
          >
          {{ coursePack.pack_name }}
        </v-btn>
        </span>
      </div>
      <div v-if="selectedCourseList.length < 1" class="text-center">
        <v-progress-circular indeterminate color="secondary" />
      </div>
      <validation-observer ref="observer">
        <v-form @submit.prevent ref="form">
          <div class="text-center">
            <v-btn
              v-if="isCampaignPeriod"
              type="submit"
              :loading="isLoading"
              :disabled="!activeSaveBtn"
              @click="save"
              class="mx-2 mb-8"
              color="primary"
            >
              保存
            </v-btn>
          </div>
          <v-row align="center" v-for="(selected, index) of selectedCourseList" :key="index">
            <v-col v-if="!selected.isReadOnly & isCampaignPeriod & !selected.isPackCourse"
              cols="9"
              md="8" offset-md="2"
            >
              <v-select
                v-model="selectedCourseList[index]"
                :items="createOptionsList(selected.value.id)"
                :label="'コース' + (index + 1)"
                return-object
                hide-details="auto"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col v-if="selected.isReadOnly || !isCampaignPeriod || selected.isPackCourse"
              cols="9"
              md="8" offset-md="2"
              style="padding-top:0px; margin-top:-1px"
              >
              <span class="disabled-course-num">コース{{(index + 1) }}</span>
              <p class="disabled-course-name">{{ selectedCourseList[index].text }}</p>
            </v-col>
            <v-btn
              color="info"
              v-if="!!selected.value.detailedDocumentFileName"
              @click="openDetailPDF(selected.value.detailedDocumentFileName)"
            >
              詳細
            </v-btn>
            <v-col
              v-show="findOptionCustomFlag(selected.value.id)"
              cols="9"
              md="8" offset-md="2"
            >
              <validation-provider
                name="カスタム目標"
                :rules="{required_if: findOptionCustomFlag(selected.value.id)}"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="selectedCourseList[index].customObjective"
                  label="目標を入力してください"
                  hide-details="auto"
                  :error-messages="errors"
                  :disabled="selected.isReadOnly || !isCampaignPeriod"
                  prepend-icon="mdi-lead-pencil"
                  outlined
                  dense
                ></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <!--------------------------- アプリチャレンジ関連 --------------------------->
          <!-- キャンセルメッセージの表示 -->
          <v-row v-if="getCampaign.is_app_challenge && (appEntryStatus === 'Canceled' || appEntryStatus === 'Expired')">
            <v-col cols="12" md="8" offset-md="2">
              <v-alert
                border="left"
                colored-border
                type="error"
                elevation="2"
                style="font-size: 90%"
                class="mt-4"
              >
                <span v-if="appEntryStatus === 'Canceled'">
                  <b>食事バッチリ！アプリチャレンジコース（略：アプリチャレンジコース）がキャンセルになりました。</b><br/>
                  期限内にパスコードを登録完了されなかったため、キャンセルになりました。<br/>
                  アプリチャレンジコースには参加できませんので、再度コース設定をしてください。
                </span>
                <span v-else-if="appEntryStatus === 'Expired'">
                  <b>食事バッチリ！アプリチャレンジコース（略：アプリチャレンジコース）がキャンセルになりました。</b><br/>
                  募集人数の上限に達したため、アプリチャレンジコースには参加できません。再度コースの設定をして下さい。
                </span>
              </v-alert>
            </v-col>
          </v-row>

          <!-- 選択リスト部分 -->
          <v-row v-if="getCampaign.is_app_challenge && selectedCourseList.length >= 1" class="mt-4">
            <v-col
              v-if="appEntryStatus === 'Unregistered' || appEntryStatus == 'Canceled' || appEntryStatus === 'Expired'"
              cols="12" md="8" offset-md="2"
              >
              <v-select
                v-if="isAppEntryPeriod"
                v-model="selectedAppStatus"
                :items="appEntryOptionsList"
                label="食事バッチリ！アプリチャレンジコース"
                hide-details="auto"
                outlined
                dense
              ></v-select>
              <v-text-field
                v-else
                value="募集期間終了"
                label="食事バッチリ！アプリチャレンジコース"
                hide-details="auto"
                :disabled="true"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col v-else>
              <v-row>
                <v-col
                  cols="12" md="5" offset-md="2">
                  <v-text-field
                    value="アプリチャレンジコース"
                    label="食事バッチリ！アプリチャレンジコース"
                    hide-details="auto"
                    :disabled="true"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="3" v-if="appEntryStatus === 'Temporary' || appEntryStatus === 'Waiting'">
                  <div class="orange rounded white--text" justify="center" align="center" style="height:40px; line-height: 40px">
                    <span v-if="appEntryStatus === 'Temporary'">仮登録中</span>
                    <span v-else-if="appEntryStatus === 'Waiting'">キャンセル待ち</span>
                  </div>
                </v-col>
                <v-col cols="6" md="3" v-if="appEntryStatus === 'Completion'">
                  <div class="red rounded white--text" justify="center" align="center" style="height:40px; line-height: 40px">
                    <v-icon color="white">mdi-check-circle</v-icon> 登録完了
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </validation-observer>
    </div>
    <Dialog ref="confirm"/>
    <v-dialog v-model="coursePackAlertDialog"  width="400px">
      <v-card>
        <v-toolbar
          flat
          dense
          class="d-flex"
          >
        </v-toolbar>
        <v-card-text>
        {{ coursePackDialogMessage }}
        </v-card-text>
        <div class="text-center">
          <v-btn
            color="info"
            class="mb-4"
            @click="coursePackAlertDialog = false"
            >
            OK
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import { translate } from '@/i18n'
import { required_if as requiredIf } from 'vee-validate/dist/rules'
import { localize, extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import dayjs from 'dayjs'
const Dialog = () => import('../util/Dialog.vue')
const ProcessCourse = () => import('../process/Course')
const ProcessParticipation = () => import('../process/Participation')

// バリデーションの定義
setInteractionMode('eager')
localize('ja', ja)
extend('required_if', requiredIf)

const listCourseQuery = (campaignId) => `
  query getListCourse {
    listCourse(campaign_id: "${campaignId}") {
      courses {
        id
        name
        complete_course_weight
        complete_advanced_course_weight
        custom_goal_setting
        detailed_document_file_name
        is_selectable
        unit
      }
    }
  }
`
const getListCourse = async (campaignId) => {
  const { data: { listCourse: data } } = await GraphqlAPI(listCourseQuery(campaignId))
  return {
    courses: data.courses.map((item) => {
      return {
        id: item.id,
        name: item.name,
        completeCourseWeight: item.complete_course_weight,
        completeAdvancedCourseWeight: item.complete_advanced_course_weight,
        customGoalSetting: item.custom_goal_setting,
        detailedDocumentFileName: item.detailed_document_file_name,
        isSelectable: item.is_selectable,
        unit: item.unit
      }
    })
  }
}
const getCampaignUserQuery = (campaignId) => `
  query getCampaignUser {
    getCampaignUser(campaign_id: "${campaignId}") {
      course
      custom_objective_list {
        course_id
        custom_objective
      }
      selected_course_pack
    }
  }
`
const getCampaignUserCourse = async (campaignId) => {
  const { data: { getCampaignUser: data } } = await GraphqlAPI(getCampaignUserQuery(campaignId))
  return {
    course: data.course,
    customObjectiveList: data.custom_objective_list,
    selectedCoursePack: data.selected_course_pack
  }
}
const convertArrayString = (arrayData) => {
  const resArry = arrayData.map(obj => {
    const arr = Object.keys(obj).map(key => {
      return `${key}: ${JSON.stringify(obj[key])}`
    })
    return `{${arr.join(', ')}}`
  })
  return `[${resArry.join(', ')}]`
}
const registrationCourseMutation = (campaignId, courseInfoList, selectedCoursePack) => `
  mutation postRegistrationCourse {
    registrationCourse(
      input: {
        campaign_id: "${campaignId}",
        custom_objective_list: ${convertArrayString(courseInfoList)},
        selected_course_pack: "${selectedCoursePack}"
      }
    ) {
      username
      courses {
        id
      }
    }
  }
`
const registrationCourse = async (campaignId, courseInfoList, selectedCoursePack) => {
  const { data: { registrationCourse: data } } = await GraphqlAPI(registrationCourseMutation(campaignId, courseInfoList, selectedCoursePack))
  return {
    username: data.username,
    courses: data.courses
  }
}

const checkAppUserStatusQuery = (campaignId) => `
  query checkAppUserStatus {
    checkAppUserStatus (campaign_id: "${campaignId}")
  }
`
const checkAppUserStatus = async (campaignId) => {
  const { data: { checkAppUserStatus: data } } = await GraphqlAPI(checkAppUserStatusQuery(campaignId))
  return data
}

const listCoursePackQuery = (campaignId) => `
  query listCoursePack {
    listCoursePack(
      campaign_id: "${campaignId}"
      ) {
        course_packs {
          id
          pack_name
          pack_target
          pack_detail
          pack_category
          pack_course_list {
            course_id
            course_detail
          }
        }
      }
    }
    `
const getListCoursePackQuery = async (campaignId) => {
  const { data: { listCoursePack: data } } = await GraphqlAPI(listCoursePackQuery(campaignId))
  return data
}
export default {
  name: 'course',
  props: ['courseRanking', 'routedCoursePackId'],
  components: {
    ValidationProvider,
    ValidationObserver,
    Dialog,
    ProcessCourse,
    ProcessParticipation
  },
  data () {
    return {
      logger: {},
      selectedCourseList: [],
      customizedCourseList: [],
      courseOptions: [],
      completeCourseWeightSum: 0,
      completeAdvancedCourseWeightSum: 0,
      initUserCourse: [],
      coursePackList: [],
      packCoursesList: [],
      selectedCoursePack: '',
      isLoading: false,
      hasError: false,
      errorMessage: '',
      isReadOnly: false,
      isCampaignPeriod: false,
      isCampaignStarted: false,
      courseDialog: false,
      participationDialog: false,
      coursePackAlertDialog: false,
      activeSaveBtn: false,
      selectMessage: '',
      coursePackDialogMessage: '',

      // アプリチャレンジ関連
      appEntryOptionsList: [],
      selectedAppStatus: null,
      appEntryStatus: null,
      isAppEntryPeriod: false
    }
  },
  computed: {
    getCampaign () {
      return this.$store.getters.getCampaign
    },
    getCampaignOption () {
      return this.$store.getters.getCampaignOption
    },
    // 運用テストかどうか（健チャレLight版）
    isLight () {
      return process.env.VUE_APP_IS_LIGHT
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  watch: {
    selectedCourseList: {
      handler (newValue) {
        var courseWeightSum = 0
        var courseAdvancedWeightSum = 0
        for (var i = 0; i < newValue.length; i++) {
          if (newValue[i].value.id && newValue[i].value.completeCourseWeight) {
            courseWeightSum += newValue[i].value.completeCourseWeight
          }
          if (newValue[i].value.id && newValue[i].value.completeAdvancedCourseWeight) {
            courseAdvancedWeightSum += newValue[i].value.completeAdvancedCourseWeight
          }
        }
        this.completeCourseWeightSum = courseWeightSum
        this.completeAdvancedCourseWeightSum = courseAdvancedWeightSum
      },
      deep: true
    }
  },
  async created () {
    if (!this.getCampaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    // 期間の取得
    const start = dayjs(this.getCampaign.start, 'YYYY-MM-DD')
    const siteClose = dayjs(this.getCampaign.site_close, 'YYYY-MM-DD').add(1, 'days')
    this.isCampaignStarted = start <= dayjs()
    this.isCampaignPeriod = dayjs() < siteClose
  },
  async mounted () {
    try {
      if (!this.getCampaign.id) {
        await this.$store.dispatch('initCampaign')
      }

      // 既にコースを1件以上登録していて、コース設定可能期限をすぎるとReadOnly
      const courseDeletableEnd = dayjs(this.getCampaign.course_deletable_end, 'YYYY-MM-DD').add(1, 'days')
      this.isReadOnly = this.$store.getters.getRegisteredCourse && dayjs() >= courseDeletableEnd
      this.activeSaveBtn = !this.isReadOnly

      // 全てのコース情報の取得
      await this.fetchCourses()

      // おすすめコースパック情報の取得
      await this.fetchListCoursePack()

      // ユーザが選択しているコースの情報を取得
      await this.fetchUserCourseData()

      // コースパック画面からの遷移の場合、assingCoursePack内で選択したコースパックを割り当てる
      if (this.routedCoursePackId) {
        if (!this.isCampaignPeriod) {
          this.coursePackDialogMessage = 'キャンペーン期間が終了したため、コースの登録・変更はできません。'
          this.coursePackAlertDialog = true
        } else if (this.isReadOnly) {
          this.coursePackDialogMessage = 'コース変更可能期間が過ぎたため、パックの追加はできません。コースの追加は可能です。(最大' + this.selectedCourseList.length + 'コースまで)'
          this.coursePackAlertDialog = true
        } else if (this.selectedCoursePack !== this.routedCoursePackId) {
          this.assignCoursePack(this.routedCoursePackId)
          this.coursePackDialogMessage = '選択したおすすめパックを設定するには、「保存」ボタンを押下してください。'
          this.coursePackAlertDialog = true
        }
      }

      // アプリチャレンジ初期値設定
      if (this.getCampaign.is_app_challenge) {
        this.isAppEntryPeriod = dayjs() < dayjs(this.getCampaign.app_deadline_date, 'YYYY-MM-DD').add(15, 'hour')
        this.appEntryOptionsList = [
          { text: '未エントリー', value: 'isNotEntry' },
          { text: 'アプリチャレンジコース', value: 'isEntry' }
        ]
        this.appEntryStatus = await checkAppUserStatus(this.getCampaign.id)
        this.$store.dispatch('setAppEntryStatus', this.appEntryStatus)
        if (this.appEntryStatus === 'Unregistered' || this.appEntryStatus === 'Canceled') {
          this.selectedAppStatus = 'isNotEntry'
        }
        if (this.isAppEntryPeriod && this.selectedAppStatus === 'isNotEntry') {
          this.activeSaveBtn = true
        }
      }
      if (this.selectedCourseList.length >= 1) {
        if (!this.isCampaignPeriod) {
          this.selectMessage = 'キャンペーン期間が終了したため、コースの登録・変更はできません。'
        } else if (this.isReadOnly) {
          this.selectMessage = 'コース変更可能期間が過ぎたため、コースの変更はできません。コースの追加は可能です。(最大' + this.selectedCourseList.length + 'コースまで)'
        } else {
          if (this.getCampaign.is_course_select_validation && !this.isLight) {
            this.selectMessage = 'お好きなコースを' + this.getCampaign.required_total_course_count + 'コース以上'
            if (this.getCampaign.required_advanced_course_count > 0) {
              this.selectMessage += '（アドバンスコース' + this.getCampaign.required_advanced_course_count + 'コース以上含む）'
            }
            this.selectMessage += '、選択してください。<br>'
          } else if (this.getCampaign.is_course_select_validation && this.isLight) {
            this.selectMessage = 'お好きなコースを' + this.getCampaign.required_total_course_count + 'コース以上'
            if (this.getCampaign.required_advanced_course_count > 0) {
              this.selectMessage += 'かつ、アドバンスコース（★★）を' + this.getCampaign.required_advanced_course_count + 'コース以上含むように'
            }
            this.selectMessage += '、選択してください。<br>'
          }
        }
      }
    } catch (e) {
      this.$log.debug(e)
      this.$emit('errorHandling', 'システムエラーが発生しました。')
    }
  },
  methods: {

    // 全てのコースを取得する
    async fetchCourses () {
      try {
        const getListCourseResult = await getListCourse(this.getCampaign.id)
        getListCourseResult.courses.forEach(course => {
          this.courseOptions.push({
            text: course.name,
            value: course
          })
        })
      } catch (e) {
        this.$emit('errorHandling', 'コースの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },

    // ユーザが選択しているコースを取得する
    async fetchUserCourseData () {
      try {
        const getCampaignUserResult = await getCampaignUserCourse(this.getCampaign.id)
        const resultList = getCampaignUserResult.customObjectiveList
        let packCourseList = []
        if (getCampaignUserResult.selectedCoursePack) {
          const coursePack = this.coursePackList.find(pack => pack.id === getCampaignUserResult.selectedCoursePack)
          packCourseList = coursePack.pack_course_list
          this.selectedCoursePack = getCampaignUserResult.selectedCoursePack
        }
        this.selectedCourseList = this.setCourseList(resultList, packCourseList)
        this.initUserCourse = getCampaignUserResult.course
        if (!this.selectedCoursePack) {
          this.customizedCourseList = this.selectedCourseList
        } else {
          for (let i = 0; i < this.getCampaign.max_course_select; i++) {
            this.customizedCourseList[i] = {
              text: '選択してください',
              value: {
                id: '',
                name: '',
                completeCourseWeight: 0,
                completeAdvancedCourseWeight: 0,
                customGoalSetting: false,
                detailedDocumentFileName: ''
              },
              isPackCourse: false
            }
          }
          this.packCoursesList[this.selectedCoursePack] = JSON.parse(JSON.stringify(this.selectedCourseList))
        }
      } catch (e) {
        this.$emit('errorHandling', '選択済みコースの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },

    // コースパックを取得する
    async fetchListCoursePack () {
      try {
        const listCoursePackResult = await getListCoursePackQuery(this.getCampaign.id)
        listCoursePackResult.course_packs.forEach(coursePack => {
          this.coursePackList.push(coursePack)
        })
        this.coursePackList.forEach(coursePack => {
          this.packCoursesList[coursePack.id] = this.setCourseList(coursePack.pack_course_list, coursePack.pack_course_list)
        })
      } catch (e) {
        alert('おすすめパックリストの取得でエラーが発生しました')
      }
    },
    findOptionCustomFlag (id) {
      if (id) {
        const elm = this.courseOptions.find(option =>
          option.value.id === id
        )
        return elm.value.customGoalSetting
      } else {
        return false
      }
    },

    // コースの選択リスト値を設定する
    createOptionsList (id) {
      const me = this

      // 選択中のコースと、「コース選択可能にするか」がfalseになっているコースは、選択リストから除外する
      let optionList = this.courseOptions.filter(option => {
        const fItem = me.selectedCourseList.find(selected => selected.value.id === option.value.id)
        return (!fItem || fItem.value.id === id) && option.value.isSelectable
      })

      // 選択中のコースに、単位を「歩」とするコースがある場合は、選択リストから単位「歩」の他のコースを除外する
      if (me.selectedCourseList.find(selected => selected.value.unit === '歩')) {
        optionList = optionList.filter(option => {
          return option.value.unit !== '歩' || option.value.id === id
        })
      }
      const formattedOptionList = optionList.map(option => {
        return {
          text: option.text,
          value: option.value
        }
      })
      formattedOptionList.unshift({
        text: '選択してください',
        value: {
          id: '',
          name: '',
          completeCourseWeight: 0,
          completeAdvancedCourseWeight: 0,
          customGoalSetting: false,
          detailedDocumentFileName: ''
        }
      })
      return formattedOptionList
    },
    checkCustomObjective () {
      var customStatus = true
      const courseInfoList = this.courseInfoList()
      for (let i = 0; i < courseInfoList.length; i++) {
        if (courseInfoList[i].course_id && this.findOptionCustomFlag(courseInfoList[i].course_id) && !courseInfoList[i].custom_objective) {
          customStatus = false
        }
      }
      return customStatus
    },
    checkDuplicate () {
      let courseIdList = this.selectedCourseList.map((selected) => {
        if (selected.value.id && selected.value.id !== '') {
          return selected.value.id
        }
      })
      courseIdList = courseIdList.filter(Boolean)
      var s = new Set(courseIdList)
      return s.size !== courseIdList.length
    },
    courseInfoList () {
      var courseInfoList = this.selectedCourseList.map((selected) => {
        var courseInfo = {}
        if (selected.value.id && selected.value.id !== '') {
          courseInfo.course_id = selected.value.id
          if (selected.customObjective && this.findOptionCustomFlag(selected.value.id)) {
            courseInfo.custom_objective = selected.customObjective
          }
        }
        return courseInfo
      })
      courseInfoList = courseInfoList.filter(courseInfo => {
        return courseInfo.course_id
      })
      return courseInfoList
    },
    deleteCourseCheck () {
      // 前回との変更チェック
      const conditionList = this.initUserCourse.map(initId => {
        return !this.courseInfoList().some(courseInfo => courseInfo.course_id === initId)
      })
      const deleteStatus = conditionList.some(condition => condition)
      return deleteStatus
    },
    async save () {
      this.isLoading = true
      this.hasError = false

      // アプリチャレンジを選択している場合、コース選択しなくても良い
      const isAppEntry = this.getCampaign.is_app_challenge && this.selectedAppStatus === 'isEntry'
      if ((this.completeCourseWeightSum === 0 && !isAppEntry) || (this.initUserCourse.length >= 1 && this.completeCourseWeightSum === 0)) {
        this.setError('emptyCourse')
        return false

      // アプリチャレンジを選択していた場合も、コース選択から未選択へは戻せない
      } else if (this.$store.getRegisteredCourse && this.completeCourseWeightSum === 0) {
        this.setError('emptyCourse')
        return false
      }

      // その他バリデーション
      if (this.completeCourseWeightSum >= 1 && !this.courseValidation()) {
        return false
      }
      try {
        if (this.initUserCourse.length >= 1) {
          // コース変更があるか。なければ保存処理不要
          if (this.deleteCourseCheck() && this.isCampaignStarted) {
            const ans = await this.$refs.confirm.open(null, 'コースを変更します。よろしいですか？')
            if (!ans) {
              this.isLoading = false
              return
            }
          }
        }
        await registrationCourse(this.getCampaign.id, this.courseInfoList(), this.selectedCoursePack)
        this.isLoading = false
        this.$emit('fetchCampaignUser')
        this.$store.dispatch('setRegisteredCourse', true)
        this.toNextPage()
      } catch (e) {
        this.setError('unexpectedError')
        this.$log.debug(e)
      }
    },
    // おすすめコースパックを選択した場合に動作し、selectedCourseListをパックのものに変更する
    assignCoursePack (coursePackId) {
      try {
        if (this.selectedCoursePack !== coursePackId) {
          if (!this.selectedCoursePack) {
            this.customizedCourseList = JSON.parse(JSON.stringify(this.selectedCourseList))
          } else {
            this.packCoursesList[this.selectedCoursePack] = JSON.parse(JSON.stringify(this.selectedCourseList))
          }
          this.selectedCourseList = JSON.parse(JSON.stringify(this.packCoursesList[coursePackId]))
          this.selectedCoursePack = coursePackId
        }
      } catch (e) {
        this.$emit('errorHandling', 'おすすめパックの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    // コースパックを選択していない状態に変更する。
    customize () {
      if (this.selectedCoursePack) {
        this.packCoursesList[this.selectedCoursePack] = JSON.parse(JSON.stringify(this.selectedCourseList))
        this.selectedCourseList = JSON.parse(JSON.stringify(this.customizedCourseList))
        this.selectedCoursePack = ''
      }
    },
    // selectedCourseListにcourseListの値を割り当てる。コースパックを選択している場合、選択不可とする。
    setCourseList (courseList, packCourseList) {
      const selectedCourseList = []
      for (let i = 0; i < this.getCampaign.max_course_select; i++) {
        if (courseList[i]) {
          const target = this.courseOptions.find(option => {
            return option.value.id === courseList[i].course_id
          })
          if (target) {
            selectedCourseList[i] = {
              ...target,
              isReadOnly: this.isReadOnly,
              isPackCourse: false
            }
            if (packCourseList[i]) {
              selectedCourseList[i].isPackCourse = true
            }
            if (courseList[i].custom_objective) {
              selectedCourseList[i].customObjective = courseList[i].custom_objective
            }
          }
        } else {
          this.activeSaveBtn = true
          selectedCourseList[i] = {
            text: '選択してください',
            value: {
              id: '',
              name: '',
              completeCourseWeight: 0,
              completeAdvancedCourseWeight: 0,
              customGoalSetting: false,
              detailedDocumentFileName: ''
            },
            isPackCourse: false
          }
        }
      }
      return selectedCourseList
    },
    courseValidation () {
      if (this.getCampaign.is_course_select_validation && this.completeCourseWeightSum < this.getCampaign.required_total_course_count) {
        this.setError('requiredCourseCount')
        return false
      } else if (this.getCampaign.is_course_select_validation && this.completeAdvancedCourseWeightSum < this.getCampaign.required_advanced_course_count) {
        this.setError('requiredAdvanceCourseCount')
        return false
      } else if (this.checkDuplicate()) {
        this.setError('buplicateCourse')
        return false
      } else if (!this.checkCustomObjective()) {
        this.setError('customCourseEmptyObjective')
        return false
      } else if (!this.isCampaignPeriod) {
        this.setError('notChangeCourse')
        return false
      }
      return true
    },
    setError (errorType) {
      this.isLoading = false
      this.hasError = false
      if (errorType === 'notChangeCourse') {
        this.errorMessage = `${translate('course.errors.notChangeCourse')}`
      } else if (errorType === 'emptyCourse') {
        this.errorMessage = `${translate('course.errors.emptyCourse')}`
      } else if (errorType === 'requiredCourseCount') {
        this.errorMessage = `${translate('course.errors.requiredCourseCount', { num: this.getCampaign.required_total_course_count })}`
      } else if (errorType === 'requiredAdvanceCourseCount') {
        this.errorMessage = `${translate('course.errors.requiredAdvanceCourseCount', { num: this.getCampaign.required_advanced_course_count })}`
      } else if (errorType === 'buplicateCourse') {
        this.errorMessage = `${translate('course.errors.buplicateCourse')}`
      } else if (errorType === 'customCourseEmptyObjective') {
        this.errorMessage = `${translate('course.errors.customCourseEmptyObjective')}`
      } else if (errorType === 'unexpectedError') {
        this.errorMessage = `${translate('course.errors.unexpectedError')}`
      }
      this.hasError = true
      return false
    },
    toNextPage () {
      if (this.getCampaign.is_app_challenge && this.selectedAppStatus === 'isEntry') {
        this.$router.push('/app_entry', () => {})
      } else {
        this.$router.push({
          name: 'result',
          params: { referer: 'update_course' }
        }, () => {})
      }
    },
    toCourse () {
      this.courseDialog = true
    },
    toProcess () {
      this.participationDialog = true
    },
    toCoursePack () {
      this.$router.push('/course_pack')
    },
    pdfRecommend () {
      window.open('/course/recommend_course.pdf', '_blank')
    },
    openDetailPDF (target) {
      if (this.isLight) {
        window.open('/course/detail/' + target + '_light.pdf', '_blank')
      } else {
        window.open('/course/detail/' + target + '.pdf', '_blank')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.course {
  margin: 10px;
}
.course-title {
  margin-bottom: 1rem;
}
.course-btn {
  width: 10rem;
}
.rank-icon {
  margin: 7px 16px 7px 20px !important;
}
.disabled-course-num {
  font-size:12px;
  margin-top:-1px;
  margin-left:11.5px;
}
.disabled-course-name {
  font-size: 16px;
  margin-left:12px;
  margin-top:-4px;
  margin-bottom:7.5px;
}
</style>
